import axios from 'axios';
export const login = async (values , UserId) => {
    let userInfo;
    if(values.password === ""){
        userInfo = {     
            LoginUserId : UserId,   
            LoginId: String(values.loginId),  
        }
    }else{
        userInfo = {     
            LoginUserId : UserId,   
            LoginId: String(values.loginId),
            LoginPassword: values.password,        
        }
    }
    try {
        let response;
        response = await axios.post(`/api/auth/SignIn`, userInfo);
        return response.data;

    } catch (error) {
        console.error(error);
    }
}
export const suspendAccount = async (values) => {
    let userInfo = {
        UserKey: values.rowKey,
        timestamp: values.timestamp,
    }
    try {
        let response = await axios.post(`/api/auth/suspendAccount`, userInfo)
        return response.data;
    } catch (error) {
        console.error(error)
    }
}

export const logout = async () => {
    let response = await axios.post('/api/auth/SignOut');
    return response.data;
}

export const updateCurrentSession = async () => {
    try{
        let response = await axios.post('/api/auth/updateCurrentSession');
        return response.data;
    }catch(error){
        return {
            status:false,
            message:error,
        }
    }
}